import { comparerByDate } from '@app/comparers';
import { Department, Season } from '@app/models';
import { Follow, getFollowDepartmentName } from '@app/models/follow';
import {
  AuthActionsUnion,
  AuthActionTypes
} from '@app/modules/core/actions/auth.actions';
import {
  FollowActionsUnion,
  FollowActionTypes
} from '@core/actions/follow.actions';
// import * as fromRoot from "@core/reducers/root.reducer";
import * as fromDepartments from '@core/reducers/department.reducer';
import * as fromFollowGroups from '@core/reducers/follow-group.reducer';
import * as fromSeasons from '@core/reducers/season.reducer';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export interface State extends EntityState<Follow> {
  loading: boolean;
  loadingCountries: boolean;
  creatingSetting: boolean;
  FollowIds: number[];
  loaded: boolean;
  filter: boolean;
  banners: any[];
  summary: any[];
  followsNoMembers: any[];
  followsNoMembersLoading: boolean;
  tableCountryBuyer: any[];
  check: boolean,
  followYears: any[]
}

export const adapter: EntityAdapter<Follow> = createEntityAdapter<Follow>({
  selectId: (follow: Follow) => follow.id,
  sortComparer: comparerByDate('DESC', 'createdAt')
});

export const INITIAL_STATE: State = adapter.getInitialState({
  loading: false,
  loadingCountries: false,
  creatingSetting: false,
  FollowIds: [],
  loaded: false,
  filter: false,
  banners: [],
  summary: [],
  followsNoMembers: [],
  followsNoMembersLoading: false,
  tableCountryBuyer: [],
  check: false,
  followYears: []
});

export const getSeasonsState = createFeatureSelector<fromSeasons.State>(
  'seasons'
);

export const getSeasons = createSelector(
  getSeasonsState,
  fromSeasons.selectAll
);

export const getSeasonEntities = createSelector(
  getSeasonsState,
  fromSeasons.selectEntities
);

export const getFollowGroupsState = createFeatureSelector<
  fromFollowGroups.State
>('followGroups');

export const getFollowGroupEntities = createSelector(
  getFollowGroupsState,
  fromFollowGroups.selectEntities
);
export const getDepartmentsState = createFeatureSelector<fromDepartments.State>(
  'departments'
);

export const getDepartmentEntities = createSelector(
  getDepartmentsState,
  fromDepartments.selectEntities
);

export function reducer(
  state: State = INITIAL_STATE,
  action: FollowActionsUnion | AuthActionsUnion
) {
  switch (action.type) {
    case FollowActionTypes.Load:
    case FollowActionTypes.GetBannerShowroomFood:
      return { ...state, loading: true };

    case FollowActionTypes.LoadFail:
    case FollowActionTypes.GetBannerShowroomFoodFail:
      return { ...state, loading: false };

    case FollowActionTypes.GetSummaryData:
      return {
        ...state, 
        loading: true,
      }
    case FollowActionTypes.GetSummaryDataPending:
      return {
        ...state, 
        loading: true,
        summary: action.data,
      }
    
    case FollowActionTypes.GetSummaryDataFail:
      return {
        ...state, 
        loading: false
      }

    case FollowActionTypes.GetSummaryDataSuccess:
      return {
        ...state, 
        summary: action.data,
        loading: false
      }

    case FollowActionTypes.LoadSuccess:
      return adapter.addAll(action.follows, {
        ...state,
        loading: false,
        loaded: true
      });

    case FollowActionTypes.GetBannerShowroomFoodSuccess:
      return {
        ...state,
        loading: false,
        loaded: true,
        banners: action.banner
      }

    case FollowActionTypes.LoadSingle:
      return { ...state, loading: true };

    case FollowActionTypes.LoadSingleFail:
      return { ...state, loading: false };

    case FollowActionTypes.LoadSingleSuccess:
      return adapter.upsertOne(action.follow, {
        ...state,
        loading: false
      });

    case FollowActionTypes.LoadCountries:
      return { ...state, loadingCountries: true };

    case FollowActionTypes.LoadCountriesSuccess:
    case FollowActionTypes.LoadCountriesFail:
      return { ...state, loadingCountries: false };

    case FollowActionTypes.CreateSetting:
      return { ...state, creatingSetting: true };

    case FollowActionTypes.CreateSettingSuccess:
    case FollowActionTypes.CreateSettingFail:
      return { ...state, creatingSetting: false };

    case FollowActionTypes.UpdateOne:
      return adapter.updateOne(
        { id: action.follow.id, changes: action.follow },
        state
      );

    case FollowActionTypes.FollowsNoMembers:
      return {...state, followsNoMembersLoading: true}
    
    case FollowActionTypes.FollowsNoMembersSuccess:
      return {...state, followsNoMembers: action.data, followsNoMembersLoading: false}

    case FollowActionTypes.UpsertSetting: {
      let changes;
      const entities = Object.keys(state.entities)
        .map(id => state.entities[id])
        .filter(
          follow =>
            follow.id === action.followId || follow.ParentId === action.followId
        );

      action.setting.map(x => {
        switch (x.type) {
          case 'ExchangeRate':
            changes = entities.map(entity => {
              let rates = state.entities[entity.id].ExchangeRates || [];
              rates = [...rates.filter(r => r.name !== x.name), x];
              return { ...entity, ExchangeRates: rates };
            });
            break;

          case 'Tax':
            changes = entities.map(entity => {
              let taxes = state.entities[entity.id].Taxes || [];
              taxes = [...taxes.filter(r => r.name !== x.name), x];
              return { ...entity, Taxes: taxes };
            });
            break;
          case 'Factor':
            changes = entities.map(entity => {
              let factors = state.entities[entity.id].Factors || [];
              factors = [...factors.filter(r => r.name !== x.name), x];
              return { ...entity, Factors: factors };
            });
            break;
          default:
            break;
        }
      });

      const newEntities = changes.reduce((obj, x) => {
        obj[x.id] = x;
        return obj;
      }, {});

      return { ...state, entities: { ...state.entities, ...newEntities } };
    }

    case FollowActionTypes.AddOne:
      return adapter.addOne(action.follow, state);

    case AuthActionTypes.Logout:
      return INITIAL_STATE;

    case FollowActionTypes.GetFollowYearsSuccess:
      return {
        ...state,
        followYears: action.data
      }

    case FollowActionTypes.Search:
      return { ...state, loading: true, FollowIdS: [] };

    case FollowActionTypes.SearchSuccess:
      return {
        ...state,
        FollowIds: action.FollowIds.length === 0 ? [-1] : action.FollowIds,
        loading: false,
        filter: action.FollowIds.length === 0 ? false : true
      };

    case FollowActionTypes.SearchFail:
      return { ...state, loading: false, filter: false, FollowIds: [] };

    case FollowActionTypes.SearchFollowSuccess:
      return adapter.addAll(action.Follows, {
        ...state,
        loading: false,
        loaded: true
      });
    
    case FollowActionTypes.FollowsTableCountryBuyerSuccess:
      return {
        ...state,
        loading: false,
        tableCountryBuyer: action.data
      }
    case FollowActionTypes.FollowsChargeCompleteFail:
    case FollowActionTypes.FollowsChargeCompleteSuccess:
      return {
        ...state,
        loading: false,
      }
    case FollowActionTypes.FollowsCountryBuyerSuccess:
      return {
        ...state,
        check: action.data.check
      }

    default:
      return state;
  }
}

const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal
} = adapter.getSelectors();

const selectLoaded = (state: State) => state.loaded;
const selectLoading = (state: State) => state.loading;
const selectfollowNoMembersLoading = (state: State) => state.followsNoMembersLoading;

export const getFollowsState = createFeatureSelector<State>('follows');

export const getIds = createSelector(
  getFollowsState,
  selectIds
);

export const getAll = createSelector(
  getFollowsState,
  selectAll
);

export const getTableCountryBuyer = createSelector(
  getFollowsState,
  state => state.tableCountryBuyer
)

export const getCheck = createSelector(
  getFollowsState,
  state => state.check
)

export const getFollows = createSelector(
  getAll,
  follows =>
    follows.map(follow => {
      if (!follow.ParentId) {
        follow.Businesses = follows
          .filter(f => f.ParentId === follow.id)
          .reduce((arr, f) => [...arr, ...f.Businesses], []);
      }
      return follow;
    })
);

export const getFollowsLoaded = createSelector(
  getFollowsState,
  selectLoaded
);

export const getFollowsLoading = createSelector(
  getFollowsState,
  selectLoading
);

export const getFollowsYears = createSelector(
  getFollowsState,
  (state) => state.followYears
)

export const getFollowsNoMembersLoading = createSelector(
  getFollowsState,
  selectfollowNoMembersLoading
)

export const getFollowsNoMembers = createSelector(
  getSeasonEntities,
  getFollowsState,
  getFollowGroupEntities,
  getDepartmentEntities,
  (
    seasonEntities: {[id: number]: Season},
    state,
    followGroupEntities,
    departmentEntities: { [id: number]: Department },
    ) =>
    // state.followsNoMembers
    state.followsNoMembers.map((follow) => {
      const season = seasonEntities[follow.SeasonId]
      const followGroup = follow.FollowGroupId
        ? followGroupEntities[follow.FollowGroupId]
        : {};
      const department = departmentEntities[follow.DepartmentId]
        ? {
          ...departmentEntities[follow.DepartmentId],
          indexed: getFollowDepartmentName(follow, departmentEntities)
        }
        : {}
        const businessUnits =
        follow &&
        follow.Businesses &&
        follow.Businesses.reduce((arr, business) => {
          if (!arr.map(a => a.code).includes(business.code)) {
            arr = [
              ...arr,
              { name: business.name, code: business.code }
            ].sort((a, b) => a.name.localeCompare(b.name));
          }
          return arr;
        }, []);

      return {...follow, season, department, followGroup, businessUnits} 
    })
  
)

export const getFollowEntities = createSelector(
  getFollowsState,
  selectEntities
);

export const selectFilteredFollowIds = (state: State) => state.FollowIds;

export const isFilter = (state: State) => state.filter;

export const selectBannersForFood = (state: State) => state.banners;

export const getFollowIds = createSelector(
  getFollowsState,
  selectFilteredFollowIds
);

export const getIsFilter = createSelector(
  getFollowsState,
  isFilter
);

export const getBanners = createSelector(
  getFollowsState,
  selectBannersForFood
)

export const getSummaryData = createSelector(
  getFollowsState,
  (state: State) => state.summary
)